/** Sufixos societários que poluem o nome curto usado nas saudações da tela. */
const SUFIXO_SOCIETARIO = / (LTDA|S\.A\.|ME|EIRELI)\.?$/i;

export const primeiroNomeDe = (nomeCompleto: string, padrao = 'você'): string =>
  nomeCompleto.trim().split(/\s+/)[0] || padrao;

export const razaoCurtaDe = (razaoSocial: string, padrao = 'Sua empresa'): string => {
  const limpa = razaoSocial.trim().replace(SUFIXO_SOCIETARIO, '');
  return limpa || padrao;
};
